if(!customElements.get('featured-products')) {
  class ComponentFeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.swiperEl = this.querySelector('.swiper');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      this.paginationBar = this.querySelector('.pagination-bar');
      if(this.paginationBar){
        this.paginateCurrent = this.paginationBar.querySelector('.current');
        this.paginateLength = this.paginationBar.querySelector('.length');
      }

      const start = () => {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
          this.bindCardButtons();
        }, 1);
      };

      if(window.Swiper) { start(); }
      else { window.addEventListener('swiper:ready', start); }
    }

    bindCardButtons() {
      const buttons = this.querySelectorAll('.product-card-button[data-url]');
      buttons.forEach((button) => {
        if (button.dataset.bound === 'true') return;
        button.addEventListener('click', () => {
          const url = button.dataset.url;
          if (url) window.location.href = url;
        });
        button.dataset.bound = 'true';
      });
    }

    // KeenSlider slidesPerView/spacing came through as strings; coerce for Swiper.
    spv(v) { if(v === 'auto') return 'auto'; var n = parseFloat(v); return isNaN(n) ? 1 : n; }
    sp(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
    freeModeFor() {
      // Keen mode "free"/"free-snap" -> Swiper freeMode (module may be absent -> snap)
      if(this.carouselMode === 'free') return { enabled: true, sticky: false };
      if(this.carouselMode === 'free-snap') return { enabled: true, sticky: true };
      return null;
    }

    initSlider() {
      if(!this.swiperEl || typeof Swiper === 'undefined') return;
      var self = this;

      // Swiper loop stalls without enough slides to clone; fall back to rewind.
      var slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;
      var maxSpv = Math.max(parseFloat(this.slidesPerViewDesktop)||1, parseFloat(this.slidesPerViewTablet)||1, parseFloat(this.slidesPerViewMobile)||1);
      var wantLoop = this.carouselLoop == 'true';
      var canLoop = wantLoop && slideCount > 2 * maxSpv;

      var options = {
        // base = Keen "(max-width: 600px)" mobile band
        slidesPerView: this.spv(this.slidesPerViewMobile),
        spaceBetween: this.sp(this.carouselSpacingMobile),
        centeredSlides: this.carouselCenteredMobile == 'true',
        loop: canLoop,
        rewind: wantLoop && !canLoop,
        watchSlidesProgress: true,
        breakpoints: {
          // Keen "(min-width: 601px) and (max-width: 900px)" tablet band
          601: {
            slidesPerView: this.spv(this.slidesPerViewTablet),
            spaceBetween: this.sp(this.carouselSpacingTablet),
            centeredSlides: this.carouselCenteredTablet == 'true'
          },
          // Keen "(min-width: 901px)" desktop band
          901: {
            slidesPerView: this.spv(this.slidesPerViewDesktop),
            spaceBetween: this.sp(this.carouselSpacingDesktop),
            centeredSlides: this.carouselCenteredDesktop == 'true'
          }
        }
      };

      var fm = this.freeModeFor();
      if(fm) options.freeMode = fm;

      var dotsEl = this.querySelector('.keen-dots');
      if(dotsEl) options.pagination = { el: dotsEl, clickable: true };

      var prevEl = this.querySelector('.keen-arrow.prev');
      var nextEl = this.querySelector('.keen-arrow.next');
      if(prevEl && nextEl) options.navigation = { prevEl: prevEl, nextEl: nextEl };

      var seconds = parseFloat(this.carouselAutoplay) || 0;
      if(seconds > 0) options.autoplay = { delay: seconds * 1000, disableOnInteraction: false };

      if(this.paginationBar) {
        options.on = {
          slideChange: function () {
            self.paginateCurrent.textContent = (this.realIndex || 0) + 1;
            self.paginateLength.textContent = self.swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
          }
        };
      }

      this.sliderObj = new Swiper(this.swiperEl, options);
    }
  }
  customElements.define('featured-products', ComponentFeaturedProducts);
}
